import { render, staticRenderFns } from "./ContactFormModal.vue?vue&type=template&id=0c2b141f&lang=pug&"
import script from "./ContactFormModal.vue?vue&type=script&lang=js&"
export * from "./ContactFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports